import React, { useEffect, useState, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ModalBody,
  Label,
  Button,
  InputGroup,
} from "reactstrap";

import DeleteModal from "../../components/Common/DeleteModal";

import { deleteDealerById, getDealer, updateDealerStatus } from "helpers/UAM/dealer.helper";
import TableContainerV1 from "components/Common/TableContainerV1";
import { isEmpty } from "lodash";
import moment from "moment";
import ToastDialog from "common/ToastDialog";
import { useNavigate } from "react-router-dom";
import { AiOutlineSync } from "react-icons/ai";
import { getGeneralMaster } from "http/master/master";
import Flatpickr from "react-flatpickr";
import FullPageLoader from "components/Common/FullPageLoader";
import Breadcrumbs from "components/Common/Breadcrumb"
import { getApiLogs } from "http/apiLogs/apiLogs";
import { formatDateTime, isPermission } from "common/utility";
import Switch from "react-switch";
import CommonDialog from "components/Common/CommonDialog";

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 10
      }}
    >
      {" "}
      Inactive
    </div>
  );
};

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingLeft: 4
      }}
    >
      {" "}
      Active
    </div>
  );
};

const TableActionsComponent = ({ props, handleChange }) => {
  const [checked, setChecked] = useState(props.isActive);
  const newObj = props

  useEffect(() => {
    setChecked(props.isActive);
  }, [props]);

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          className="me-1 mb-sm-8 mb-2"
          onColor="#344fa0"
          width={80}
          onChange={() => {
            newObj.isActive = !newObj.isActive;
            setChecked(newObj.isActive);
            handleChange(newObj);
          }}
          checked={checked}
        />
      </DropdownToggle>
    </UncontrolledDropdown>
  );
};


const Dealers = props => {

  //meta title
  document.title = "Dealer List | DMS";
  const navigate = useNavigate();
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isSyncing, setIsSyncing] = useState(false);

  const [dealerList, setDealerList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState({});
  const [columnId, setColumnId] = useState("id");
  const [dealerInfo, setDealerInfo] = useState({});//for view modal
  const [deleteModalInfo, setDeleteModalInfo] = useState({});//for delete modal
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });
  const flatpickrRef = useRef(null);
  const [lastSynced, setLastSynced] = useState(null);
  const [syncPermission, setSyncPermission] = useState(false);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });

  const {roleName} = JSON.parse(localStorage.getItem("user"))

  const handleDeleteDealer = (dealerInfo) => {
    setDeleteModalInfo(dealerInfo);
  }

  const handleEditDealer = (dealerInfo) => {
    const enCodedId = btoa(dealerInfo.id);
    navigate(`/${roleName}/dealers/view/${enCodedId}`);
  }

  const deleteDealer = async () => {
    const { id } = deleteModalInfo;
    const response = await deleteDealerById({ id });
    if (response.status) {
      setToastInfo({ message: response.message, showToast: true, role: "success" });
      setDeleteModalInfo({});
      getDealerList();
    } else {
      setToastInfo({ message: response.message, showToast: true, role: "error" });
    }
  }

  const handleChange = (data) => {
    const message = 'Are you sure want to update dealer?'
    setShowCommonDialog({ isShow: true, message, data })
  };

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      updateDealerStatus(data)
        .then((response) => {
          if (response.status) {
            setToastInfo({
              message: "Dealer Status Updated",
              showToast: true,
              role: "success",
            });
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setShowCommonDialog({ isShow: false })
      const bodyData = {
        page: currentPage,
        searchKey: searchValue,
        limit: pageSize,
        columnName: columnId,
        sortingOrder: sortingOrderStatus,
        filterType: filters
      }

      getDealerList(bodyData);
    }
  }

  // Customber Column
  const columns = useMemo(
    () => [
      {
        Header: 'Dealer Code',
        accessor: 'dealerCode',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '-';
        }
      },
      {
        Header: 'Dealer Name',
        accessor: 'dealerName',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '-';
        }
      },
      {
        Header: 'Email',
        accessor: 'email',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '-';
        }
      },
      {
        Header: 'Phone',
        accessor: 'phone',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '-';
        }
      },
      {
        Header: 'Joining Date',
        accessor: 'joiningDate',
        Cell: (cell) => {
          return cell.value ? moment(cell.value).format("MMM DD, YYYY") : '-';
        }
      },
      {
        Header: 'Dealer Status',
        accessor: 'isActive',
        Cell: (cellProps) => {
          let elem = cellProps?.row?.original || {}
          return (
            <TableActionsComponent
              props={elem}
              handleChange={(newObj) => {
                handleChange(newObj);
              }}
            />
          );
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  className="d-flex align-items-center"
                  onClick={() => {
                    const dealerData = cellProps.row.original;
                    handleEditDealer(dealerData);
                  }
                  }
                >
                  <i className="mdi mdi-eye font-size-16 text-success me-1" id="edittooltip"></i>
                  View
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    View
                  </UncontrolledTooltip>
                </DropdownItem>

              </DropdownMenu>
            </UncontrolledDropdown>
          );
        }
      },
    ],
    []
  );


  const getDealerList = async (bodyData) => {
    const response = await getDealer(bodyData);
    if (response?.status) {
        setDealerList(response.data.data);
        const { totalItems, totalPages, currentPage } = response.data
        setPagination({
          pageIndex: currentPage,
          pageCount: totalPages,
          totalRecords: totalItems,
        })
    } else {
      setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
      setDealerList([])
    }
  }


  useEffect(() => {
    const bodyData = {
      page: currentPage,
      searchKey: searchValue,
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
      filterType: filters
    }

    getDealerList(bodyData);
    fetchLastSynced()
  }, [searchValue, pageSize, columnId, sortingOrderStatus, currentPage]);


  const handlePageChange = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  }

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
  };
  useEffect(() => {
    checkPermission()
  }, [])

  const checkPermission = async () => {
    let isSyncPermission = await isPermission('sync', 'create_permission')
    setSyncPermission(isSyncPermission)
  }

  const handleSearchFilter = (value) => {
    setSearchValue(value);
    setCurrentPage(1);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    setFilters({})
    flatpickrRef.current.flatpickr.clear();
    const bodyData = {
      filterType: {},
      page: currentPage,
      searchKey: "",
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
    }
    getDealerList(bodyData);
  };

  const handleSync = async () => {
    setIsSyncing(true);
    const res = await getGeneralMaster({ masterName: 'dealer' })
    if (res?.status) {
      setToastInfo({ message: res.message, showToast: true, role: "success" });
      getDealerList();
      fetchLastSynced()
    } else {
      setToastInfo({ message: res.message ? res.message : res.err ? res.err : "Something went wrong", showToast: true, role: "error" });
    }
    setIsSyncing(false);

  }

  const handleDateFilter = () => {
    const bodyData = {
      filterType: filters,
      page: currentPage,
      searchKey: searchValue,
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
    }
    getDealerList(bodyData);
  }

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters({
        ...filters,
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }
  };

  const customeFilterSection = (
    <div className="">
      <InputGroup>
        <Flatpickr
          ref={flatpickrRef}
          className="form-control"
          placeholder="Start Date - End Date"
          options={{
            mode: 'range',
            dateFormat: 'd-m-Y'
          }}
          value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
          onChange={handleDateChange}
        />
        <Button variant="primary"
          onClick={handleDateFilter}
          style={{ backgroundColor: "#344fa0", border: "none" }}>
          Go
        </Button>
      </InputGroup>
    </div>
  )


  const fetchLastSynced = async () => {
    try {
      let res = await getApiLogs({ masterName: 'dealer_master' })
      if (res.status) {
        setLastSynced(formatDateTime(res.data.initialDateTime))
      }
    } catch (err) {
      console.error(err)
    }
  }

  const buttonSection = (
    <>
      {syncPermission && (<div>
        <div className="d-flex justify-content-end mb-1">
          <button
            className="btn btn-success"
            type="button"
            onClick={handleSync}
          >
            <AiOutlineSync size={15} className={isSyncing ? 'rotating' : ''} /> Sync Data
          </button>
        </div>
        {lastSynced && <p className="d-flex justify-content-end ">Last Synced: {lastSynced}</p>}
      </div>)}
    </>
  )

  return (
    <React.Fragment>
      <DeleteModal
        name={"Dealer"}
        show={!isEmpty(deleteModalInfo)}
        onDeleteClick={deleteDealer}
        onCloseClick={() => setDeleteModalInfo({})}
      />
      <div className="page-content">
        {isSyncing && <FullPageLoader />}
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-1">
            <Breadcrumbs breadcrumbItem="Dealers List" />
          </div>

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainerV1
                    columns={columns}
                    data={dealerList}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    isGlobalFilter={true}
                    sortOptions={sortingOptions}
                    searchHelperText="Search by Dealer Name, Code, Email, Phone"
                    customFilterSection={customeFilterSection}
                    customSection={buttonSection}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}
        />
      }
    </React.Fragment>
  );
};

Dealers.propTypes = {
  customers: PropTypes.array,
  onGetCustomers: PropTypes.func,
  onAddNewCustomer: PropTypes.func,
  onDeleteCustomer: PropTypes.func,
  onUpdateCustomer: PropTypes.func,
};

export default Dealers;
